//When one of the options for the menu is clicked, it should change display
const toggleMenu = (menuType) => {
    window.scrollTo(0,0)
    Array.from(document.getElementsByClassName('menu-options')).forEach(version => {
        //    version refers to mobile or desktop
        Array.from(version.childNodes).forEach(option => {
            //options are: home, team, training, news, contact
            const type = option.textContent.toLowerCase().trim()
            const home_hover_div = option.childNodes[option.childNodes.length - 1]
            const isMobile = version.parentNode.attributes.id.textContent.trim().includes('mobile')
            if (type === menuType) {
                if (isMobile)
                    option.style.color = '#f7c35f';
                else
                    option.style.color = '#255946';
                home_hover_div.style.opacity = 1;
            } else if (type !== "") {
                if(isMobile)
                    option.style.color = '#FFFFFF';
                else
                    option.style.color = '#6e7673'
                home_hover_div.style.opacity = 0;
            }
        })
    })
}

export default toggleMenu;